module.exports = __webpack_public_path__ + "images/favicon-16.507cbfe3cae54c335dcb676c37f02365.png";